import {
  EXPORT_TIMESHEET,
  EXPORT_TIMESHEET_FAILURE,
  EXPORT_TIMESHEET_SUCCESS,
  FETCH_ALL_SHEET,
  FETCH_ALL_SHEET_FAILURE,
  FETCH_ALL_SHEET_SUCCESS,
  FETCH_ALL_SHIFT,
  FETCH_ALL_SHIFT_FAILURE,
  FETCH_ALL_SHIFT_SUCCESS,
  FETCH_SHEET,
  FETCH_SHEET_FAILURE,
  FETCH_SHEET_SUCCESS,
  GET_ALLOCATION_REPORT,
  GET_ALLOCATION_REPORT_FAILURE,
  GET_ALLOCATION_REPORT_SUCCESS,
  GET_SHEET_HISTORY,
  GET_SHEET_HISTORY_FAILURE,
  GET_SHEET_HISTORY_SUCCESS,
  LOCK_TIMESHEET,
  LOCK_TIMESHEET_FAILURE,
  LOCK_TIMESHEET_SUCCESS,
  SET_ACCRUAL,
  SET_ALLTIMESHEET_WEEK,
  SET_APPROVAL,
  SET_APPROVAL_FAILURE,
  SET_APPROVAL_SUCCESS,
  SET_CLOCK,
  SET_CLOCK_FAILURE,
  SET_CLOCK_SUCCESS,
  SET_CURRENT_EMP,
  SET_DEF_ACCRUAL,
  SET_DEF_PAID,
  SET_PAID,
  SET_REPORT_WEEK,
  SET_TIMESHEET,
  SET_TIMESHEET_WEEK,
  SET_WEEK_STATS,
  TOGGLE_HISTORY,
  TOGGLE_LIST_VIEW,
  TOGGLE_LOCK,
  TOGGLE_MAP_MODAL,
  TOGGLE_TIME_MODAL,
  TOGGLE_VIEW,
  UPDATE_ACCRUAL,
  UPDATE_ACCRUAL_FAILURE,
  UPDATE_ACCRUAL_SUCCESS,
  UPDATE_CLOCK,
  UPDATE_CLOCK_FAILURE,
  UPDATE_CLOCK_SUCCESS,
  GET_RANGE,
  GET_RANGE_SUCCESS,
  GET_RANGE_FAILURE,
  SET_TIMESHEET_RANGE,
  UPDATE_PAID_HOURS,
  UPDATE_PAID_HOURS_SUCCESS,
  UPDATE_PAID_HOURS_FAILURE,
  FETCH_EMPS,
  FETCH_EMPS_SUCCESS,
  FETCH_EMPS_FAILURE,
  FETCH_STATS,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  GET_PAYROLL,
  GET_PAYROLL_SUCCESS,
  GET_PAYROLL_FAILURE,
  UPDATE_PAYROLL_RANGE,
  LOCK_PAYROLL,
  LOCK_PAYROLL_SUCCESS,
  LOCK_PAYROLL_FAILURE,
  TOGGLE_LOCK_PAYROLL,
  TOGGLE_SHIFT,
  EXPORT_PAYROLL,
  EXPORT_PAYROLL_SUCCESS,
  EXPORT_PAYROLL_FAILURE,
  UPDATE_SHEET_EMPS,
  FETCH_BREAKS,
  FETCH_BREAKS_SUCCESS,
  FETCH_BREAKS_FAILURE,
  TOGGLE_GALLERY,
  SET_CURRENT_TIMESHEET,
  EXPORT_ALLOCATION,
  EXPORT_ALLOCATION_SUCCESS,
  EXPORT_ALLOCATION_FAILURE,
} from "./constants";

// List
export const fetchSheet = (payload, onSuccess) => ({
  type: FETCH_SHEET,
  payload,
  onSuccess,
});
export const fetchSheetSuccess = (payload) => ({
  type: FETCH_SHEET_SUCCESS,
  payload,
});
export const fetchSheetFailure = (payload) => ({
  type: FETCH_SHEET_FAILURE,
  payload,
});

export const setTimesheetWeek = (payload) => ({
  type: SET_TIMESHEET_WEEK,
  payload,
});
export const setAllTimesheetWeek = (payload) => ({
  type: SET_ALLTIMESHEET_WEEK,
  payload,
});
export const setCurrentEmp = (payload) => ({
  type: SET_CURRENT_EMP,
  payload,
});
export const setTimesheet = (payload) => ({
  type: SET_TIMESHEET,
  payload,
});

export const setClock = (payload) => ({
  type: SET_CLOCK,
  payload,
});
export const setClockSuccess = (payload) => ({
  type: SET_CLOCK_SUCCESS,
  payload,
});
export const setClockFailure = (payload) => ({
  type: SET_CLOCK_FAILURE,
  payload,
});

export const updateClock = (payload, onUpdate) => ({
  type: UPDATE_CLOCK,
  payload,
  onUpdate,
});
export const updateClockSuccess = (payload) => ({
  type: UPDATE_CLOCK_SUCCESS,
  payload,
});
export const updateClockFailure = (payload) => ({
  type: UPDATE_CLOCK_FAILURE,
  payload,
});

export const setApproval = (payload, onApproval) => ({
  type: SET_APPROVAL,
  payload,
  onApproval,
});
export const setApprovalSuccess = (payload) => ({
  type: SET_APPROVAL_SUCCESS,
  payload,
});
export const setApprovalFailure = (payload) => ({
  type: SET_APPROVAL_FAILURE,
  payload,
});

export const toggleTimeModal = (payload) => ({
  type: TOGGLE_TIME_MODAL,
  payload,
});

export const exportTimesheet = (payload, onSuccess) => ({
  type: EXPORT_TIMESHEET,
  payload,
  onSuccess,
});
export const exportTimesheetSuccess = (payload) => ({
  type: EXPORT_TIMESHEET_SUCCESS,
  payload,
});
export const exportTimesheetFailure = (payload) => ({
  type: EXPORT_TIMESHEET_FAILURE,
  payload,
});

export const fetchAllSheet = (payload) => ({
  type: FETCH_ALL_SHEET,
  payload,
});
export const fetchAllSheetSuccess = (payload) => ({
  type: FETCH_ALL_SHEET_SUCCESS,
  payload,
});
export const fetchAllSheetFailure = (payload) => ({
  type: FETCH_ALL_SHEET_FAILURE,
  payload,
});

export const toggleView = (payload) => ({
  type: TOGGLE_VIEW,
  payload,
});

export const fetchAllShift = (payload, onClockFetch) => ({
  type: FETCH_ALL_SHIFT,
  payload,
  onClockFetch,
});
export const fetchAllShiftSuccess = (payload) => ({
  type: FETCH_ALL_SHIFT_SUCCESS,
  payload,
});
export const fetchAllShiftFailure = (payload) => ({
  type: FETCH_ALL_SHIFT_FAILURE,
  payload,
});

export const toggleListView = (payload) => ({
  type: TOGGLE_LIST_VIEW,
  payload,
});

export const getReport = (payload) => ({
  type: GET_ALLOCATION_REPORT,
  payload,
});
export const getReportSuccess = (payload) => ({
  type: GET_ALLOCATION_REPORT_SUCCESS,
  payload,
});
export const getReportFailure = (payload) => ({
  type: GET_ALLOCATION_REPORT_FAILURE,
  payload,
});

export const setReportWeek = (payload) => ({
  type: SET_REPORT_WEEK,
  payload,
});

export const lockTimesheet = (payload, onLock) => ({
  type: LOCK_TIMESHEET,
  payload,
  onLock,
});
export const lockTimesheetSuccess = (payload) => ({
  type: LOCK_TIMESHEET_SUCCESS,
  payload,
});
export const lockTimesheetFailure = (payload) => ({
  type: LOCK_TIMESHEET_FAILURE,
  payload,
});

export const toggleLock = (payload) => ({
  type: TOGGLE_LOCK,
  payload,
});
export const toggleMapModal = (payload) => ({
  type: TOGGLE_MAP_MODAL,
  payload,
});

export const getSheetHistory = (payload) => ({
  type: GET_SHEET_HISTORY,
  payload,
});
export const getSheetHistorySuccess = (payload) => ({
  type: GET_SHEET_HISTORY_SUCCESS,
  payload,
});
export const getSheetHistoryFailure = (payload) => ({
  type: GET_SHEET_HISTORY_FAILURE,
  payload,
});

export const toggleHistory = (payload) => ({
  type: TOGGLE_HISTORY,
  payload,
});

export const updateAccrual = (payload) => ({
  type: UPDATE_ACCRUAL,
  payload,
});
export const updateAccrualSuccess = (payload) => ({
  type: UPDATE_ACCRUAL_SUCCESS,
  payload,
});
export const updateAccrualFailure = (payload) => ({
  type: UPDATE_ACCRUAL_FAILURE,
  payload,
});
export const setAccrual = (payload) => ({
  type: SET_ACCRUAL,
  payload,
});
export const setDefAccrual = (payload) => ({
  type: SET_DEF_ACCRUAL,
  payload,
});
export const setPaid = (payload) => ({
  type: SET_PAID,
  payload,
});
export const setDefPaid = (payload) => ({
  type: SET_DEF_PAID,
  payload,
});

export const setWeekStats = (payload) => ({
  type: SET_WEEK_STATS,
  payload,
});

export const getRange = (onRangeSuccess) => ({
  type: GET_RANGE,
  onRangeSuccess,
});
export const getRangeSuccess = (payload) => ({
  type: GET_RANGE_SUCCESS,
  payload,
});
export const getRangeFailure = (payload) => ({
  type: GET_RANGE_FAILURE,
  payload,
});

export const setTimesheetRange = (payload) => ({
  type: SET_TIMESHEET_RANGE,
  payload,
});
export const updatePaidHours = (payload, onUpdate) => ({
  type: UPDATE_PAID_HOURS,
  payload,
  onUpdate,
});
export const updatePaidHoursSuccess = (payload) => ({
  type: UPDATE_PAID_HOURS_SUCCESS,
  payload,
});
export const updatePaidHoursFailure = (payload) => ({
  type: UPDATE_PAID_HOURS_FAILURE,
  payload,
});
//
export const fetchEmps = (payload, onSuccess) => ({
  type: FETCH_EMPS,
  payload,
  onSuccess,
});
export const fetchEmpsSuccess = (payload) => ({
  type: FETCH_EMPS_SUCCESS,
  payload,
});
export const fetchEmpsFailure = (payload) => ({
  type: FETCH_EMPS_FAILURE,
  payload,
});
//
export const fetchStats = (payload, onSuccess) => ({
  type: FETCH_STATS,
  payload,
  onSuccess,
});
export const fetchStatsSuccess = (payload) => ({
  type: FETCH_STATS_SUCCESS,
  payload,
});
export const fetchStatsFailure = (payload) => ({
  type: FETCH_STATS_FAILURE,
  payload,
});

//
export const getPayroll = (payload, onSuccess) => ({
  type: GET_PAYROLL,
  payload,
  onSuccess,
});
export const getPayrollSuccess = (payload) => ({
  type: GET_PAYROLL_SUCCESS,
  payload,
});
export const getPayrollFailure = (payload) => ({
  type: GET_PAYROLL_FAILURE,
  payload,
});
export const updatePayrollRange = (payload) => ({
  type: UPDATE_PAYROLL_RANGE,
  payload,
});

export const lockPayroll = (payload, onSuccess) => ({
  type: LOCK_PAYROLL,
  payload,
  onSuccess,
});
export const lockPayrollSuccess = (payload) => ({
  type: LOCK_PAYROLL_SUCCESS,
  payload,
});
export const lockPayrollFailure = (payload) => ({
  type: LOCK_PAYROLL_FAILURE,
  payload,
});

export const toggleLockPayroll = (payload) => ({
  type: TOGGLE_LOCK_PAYROLL,
  payload,
});

export const toggleShift = (payload) => ({
  type: TOGGLE_SHIFT,
  payload,
});

export const exportPayroll = (payload, onSuccess) => ({
  type: EXPORT_PAYROLL,
  payload,
  onSuccess,
});
export const exportPayrollSuccess = (payload) => ({
  type: EXPORT_PAYROLL_SUCCESS,
  payload,
});
export const exportPayrollFailure = (payload) => ({
  type: EXPORT_PAYROLL_FAILURE,
  payload,
});
export const updateSheetEmps = (payload) => ({
  type: UPDATE_SHEET_EMPS,
  payload,
});

export const fetchBreaks = (payload) => ({
  type: FETCH_BREAKS,
  payload,
});
export const fetchBreaksSuccess = (payload) => ({
  type: FETCH_BREAKS_SUCCESS,
  payload,
});
export const fetchBreaksFailure = (payload) => ({
  type: FETCH_BREAKS_FAILURE,
  payload,
});

export const toggleGallery = (payload) => ({
  type: TOGGLE_GALLERY,
  payload,
});

export const setCurrentTimesheet = (payload) => ({
  type: SET_CURRENT_TIMESHEET,
  payload,
});

export const exportAllocation = (payload) => ({
  type: EXPORT_ALLOCATION,
  payload,
});
export const exportAllocationSuccess = (payload) => ({
  type: EXPORT_ALLOCATION_SUCCESS,
  payload,
});
export const exportAllocationFailure = (payload) => ({
  type: EXPORT_ALLOCATION_FAILURE,
  payload,
});
